export default __webpack_public_path__ + "static/media/Giuliana De Donno.0ef6fbb2.jpg";